function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "DAP_6_svg__d",
  d: "M0 .306h79.964v12.597H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.254 19.987a4.254 4.254 0 00-4.12 4.25 4.256 4.256 0 004.255 4.257c.306 0 .538-.034.826-.096 2.242 6.741 7.795 11.989 14.57 13.88v.071c0 3.144 2.64 6.026 5.967 6.026 3.327 0 5.968-2.882 5.968-6.026v-.178c6.452-1.985 12.064-7.198 14.248-13.854.384.113.771.177 1.192.177a4.248 4.248 0 004.247-4.256 4.264 4.264 0 00-4.265-4.257c-.072 0-.142.007-.211.01C46.09 8.938 36.861.229 25.591.229c-11.268 0-20.496 8.707-21.337 19.76",
  id: "DAP_6_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.254 19.987a4.254 4.254 0 00-4.12 4.25 4.256 4.256 0 004.255 4.257c.306 0 .538-.034.826-.096 2.242 6.741 7.795 11.989 14.57 13.88v.071c0 3.144 2.64 6.026 5.967 6.026 3.327 0 5.968-2.882 5.968-6.026v-.178c6.452-1.985 12.064-7.198 14.248-13.854.384.113.771.177 1.192.177a4.248 4.248 0 004.247-4.256 4.264 4.264 0 00-4.265-4.257c-.072 0-.142.007-.211.01C46.09 8.938 36.861.229 25.591.229c-11.268 0-20.496 8.707-21.337 19.76",
  id: "DAP_6_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.254 19.987a4.254 4.254 0 00-4.12 4.25 4.256 4.256 0 004.255 4.257c.306 0 .538-.034.826-.096 2.242 6.741 7.795 11.989 14.57 13.88v.071c0 3.144 2.64 6.026 5.967 6.026 3.327 0 5.968-2.882 5.968-6.026v-.178c6.452-1.985 12.064-7.198 14.248-13.854.384.113.771.177 1.192.177a4.248 4.248 0 004.247-4.256 4.264 4.264 0 00-4.265-4.257c-.072 0-.142.007-.211.01C46.09 8.938 36.861.229 25.591.229c-11.268 0-20.496 8.707-21.337 19.76",
  id: "DAP_6_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.254 19.987a4.254 4.254 0 00-4.12 4.25 4.256 4.256 0 004.255 4.257c.306 0 .538-.034.826-.096 2.242 6.741 7.795 11.989 14.57 13.88v.071c0 3.144 2.64 6.026 5.967 6.026 3.327 0 5.968-2.882 5.968-6.026v-.178c6.452-1.985 12.064-7.198 14.248-13.854.384.113.771.177 1.192.177a4.248 4.248 0 004.247-4.256 4.264 4.264 0 00-4.265-4.257c-.072 0-.142.007-.211.01C46.09 8.938 36.861.229 25.591.229c-11.268 0-20.496 8.707-21.337 19.76",
  id: "DAP_6_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  id: "DAP_6_svg__n",
  d: "M.015.016h8.498v7.79H.015z"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-32.3%",
  y: "-32.3%",
  width: "164.5%",
  height: "164.5%",
  filterUnits: "objectBoundingBox",
  id: "DAP_6_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("rect", {
  id: "DAP_6_svg__b",
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  rx: 60
}));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fill: "#0085D8",
  filter: "url(#DAP_6_svg__a)",
  cx: 59.5,
  cy: 73.5,
  r: 46.5
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__b"
}));

var _ref4 = /*#__PURE__*/React.createElement("use", {
  fill: "#0086D8",
  xlinkHref: "#DAP_6_svg__b"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0.9,
  fill: "#FFF",
  xlinkHref: "#DAP_6_svg__b"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#DAP_6_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165.579 98.582c-.201 11.53-47.87 20.048-106.472 19.025-58.601-1.023-105.944-11.199-105.743-22.73.202-11.53 47.87-20.048 106.472-19.025 58.602 1.023 105.944 11.2 105.743 22.73",
  fill: "#1FADDF",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.83 97.147c-.156 8.971-43.274 15.493-96.305 14.568-53.032-.926-95.895-8.949-95.739-17.92.157-8.971 43.274-15.494 96.306-14.568 53.031.925 95.895 8.949 95.738 17.92",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.135 95.55c-.113 6.49-39.302 11.068-87.532 10.226-48.23-.842-87.235-6.785-87.122-13.275.113-6.49 39.303-11.068 87.532-10.226 48.23.842 87.236 6.785 87.122 13.275",
  fill: "#1FADDF",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.914 94.668c-.084 4.786-36.016 8.04-80.257 7.268-44.241-.773-80.038-5.279-79.955-10.065.084-4.786 36.016-8.04 80.258-7.268 44.24.772 80.037 5.278 79.954 10.065",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.925 94.458c-.059 3.353-30.603 5.538-68.223 4.881s-68.069-3.906-68.01-7.259c.058-3.353 30.602-5.537 68.222-4.88 37.62.656 68.07 3.905 68.01 7.258",
  fill: "#1FADDF",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.377 94.478c-.019 1.053-26.255 1.449-58.602.884C26.428 94.798.22 93.486.24 92.434c.018-1.053 26.255-1.449 58.601-.884 32.347.564 58.554 1.876 58.536 2.928",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A0D1F0",
  d: "M-5 67h126.145v1H-5z"
}));

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__d"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M80.656 103.241c0 16.035-5.533 23.436-21.258 23.436-15.726 0-21.26-7.4-21.26-23.436 0-16.034 2.227-29.032 21.26-29.032 19.032 0 21.258 12.998 21.258 29.032",
  fill: "#F5BE9E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M79.31 86.006c.76 2.929 1.396 11.151 1.408 17.432l-10.97.08c0-8.493 3.26-15.296.894-20.605l4.287-.478s3.621.643 4.382 3.571M45.005 80.93c2.43 4.994 4.668 14.095 4.668 22.588l-11.428-.08c.013-6.28-.54-16.332.252-19.26l6.508-3.248z",
  fill: "#F5AD7F"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M59.397 122.484c-16.579 0-20.467-8.594-21.138-19.242h-.12c0 12.492 2.549 23.435 21.258 23.435 18.71 0 21.256-10.811 21.256-23.435h-.117c-.665 10.734-4.541 19.242-21.139 19.242",
  fill: "#E2E0D7"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M38.259 103.241c.67 10.65 4.56 19.242 21.138 19.242 16.597 0 20.474-8.507 21.138-19.242",
  fill: "#F7F6F2"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M83.809 111.067c0 .784-.867 1.418-1.936 1.418H70.688c-1.068 0-1.935-.634-1.935-1.418v-3.335c0-.782.867-1.417 1.935-1.417h11.185c1.07 0 1.936.635 1.936 1.417v3.335zM50.793 111.067c0 .784-.867 1.418-1.935 1.418H37.672c-1.068 0-1.935-.634-1.935-1.418v-3.335c0-.782.867-1.417 1.935-1.417h11.186c1.068 0 1.935.635 1.935 1.417v3.335z",
  fill: "#92DDF4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M41.543 101.413c-.1 0-.2-.003-.302-.007-14.48-.667-14.994-10.26-14.95-12.176.195-8.47 9.768-16.48 19.698-16.48a6.451 6.451 0 110 12.903c-2.443 0-4.677 1.436-5.89 2.695.46.073 1.032.136 1.736.168a6.452 6.452 0 01-.292 12.897",
  fill: "#F5BE9E"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M37.992 86.823c1.65 1.333 3.273 1.078 8.088 2.933v2.097c-5.592-1.874-9.002-3.471-9.594-4.608-.688-1.32 1.49-2.234 1.49-2.234s-1.178.786.016 1.812",
  fill: "#F4B18C"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M85.594 102.345c-.859 0-1.745-.067-2.655-.202a6.452 6.452 0 01-.726-12.614c-1.947-1.286-5.224-2.597-10.18-2.906a6.452 6.452 0 01.804-12.878c5.684.354 10.663 1.703 14.798 4.008 3.987 2.22 6.928 5.2 8.506 8.617 1.874 4.057 1.564 8.386-.83 11.581-2.138 2.855-5.596 4.394-9.717 4.394",
  fill: "#F5BE9E"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M95.51 92.663c-.91 7.777-11.556 6.58-16.164 6.528-.591.103-.925 2.305.45 2.895 2.697 1.155 17.996.762 17.83-10.532-.013-.974.084-6.68-8.593-12.353 3.02 2.703 7.424 5.396 6.478 13.462",
  fill: "#F7B692"
});

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.806 36.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__g",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.591.228c11.824 0 21.408 9.585 21.408 21.408 0 11.824-9.584 21.409-21.408 21.409-11.824 0-21.408-9.585-21.408-21.409C4.183 9.813 13.767.228 25.59.228",
  fill: "#F5AD7F",
  mask: "url(#DAP_6_svg__g)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.806 36.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__h"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.388 19.981a4.256 4.256 0 110 8.513 4.256 4.256 0 010-8.513",
  fill: "#F5AD7F",
  mask: "url(#DAP_6_svg__i)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.806 36.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__k",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__j"
})), /*#__PURE__*/React.createElement("path", {
  d: "M47.142 19.981a4.257 4.257 0 110 8.513 4.257 4.257 0 010-8.513",
  fill: "#F5AD7F",
  mask: "url(#DAP_6_svg__k)"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.806 36.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__m",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__l"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.538-3.177c11.823 0 21.408 9.585 21.408 21.408 0 11.824-9.585 21.408-21.408 21.408-11.824 0-21.409-9.584-21.409-21.408 0-11.823 9.585-21.408 21.409-21.408",
  fill: "#F5BE9E",
  mask: "url(#DAP_6_svg__m)"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M59.397 70.466a9.304 9.304 0 01-6.05-2.236.663.663 0 11.863-1.008 7.977 7.977 0 0010.375 0 .663.663 0 11.864 1.007 9.3 9.3 0 01-6.052 2.237",
  fill: "#D67743"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.778 67.274c1.547.465 3.474.916 5.62.916 2.145 0 4.113-.334 5.62-.917 1.234-.477.106 5.571-5.62 5.571s-7.175-6.039-5.62-5.57",
  fill: "#431B00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.342 72.157c.838.418 1.85.687 3.056.687 1.217 0 2.224-.275 3.047-.7-.437-.843-1.634-1.45-3.047-1.45-1.421 0-2.625.612-3.056 1.463",
  fill: "#EF4054"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.346 58.54c0 1.146-.596 2.082-1.324 2.082-.728 0-1.324-.936-1.324-2.081s.597-2.08 1.324-2.08c.728 0 1.324.935 1.324 2.08M52.475 58.54c0 1.146-.596 2.082-1.323 2.082-.729 0-1.324-.936-1.324-2.081s.596-2.08 1.324-2.08c.727 0 1.323.935 1.323 2.08",
  fill: "#000"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.194 32.307)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "DAP_6_svg__o",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#DAP_6_svg__n"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.243 3.512c.38.142.768.193 1.153.145.698-.087 1.2-.505 1.266-.843.035-.185-.096-.362-.393-.527-.57-.316-1.054-.085-1.36.165a2.084 2.084 0 00-.666 1.06m3.514 4.293a.77.77 0 01-.055-.002C4.156 7.552 3.118 5.914 2.815 4.96a3.128 3.128 0 01-.122-.566C1.279 3.406.403 1.768.087 1.094a.757.757 0 011.37-.643c.43.914.936 1.655 1.486 2.195.218-.523.56-.998 1.008-1.365C4.868.53 6.01.41 7.003.963c.88.49 1.31 1.289 1.144 2.138C7.944 4.15 6.89 4.996 5.583 5.158c-.326.04-.638.04-.935.006.577.63 1.665 1.023 3.161 1.129a.757.757 0 01-.052 1.512",
  fill: "#FCE55A",
  mask: "url(#DAP_6_svg__o)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.632 129.506c-8.367-.848-13.647-10.053-13.179-17.245.383-5.864 7.847-7.95 14.836-6.847 4.536 5.16 7.787 17.575 6.92 18.363-.868.787-4.354.292-6.49-.003-4.27-.59-2.087 5.732-2.087 5.732",
  fill: "#F5BE9E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.785 115.07c-1.611-2.284-3.881-4.674-7.158-1.795-3.278 2.878-2.932 7.066-1.61 8.746 1.32 1.681 2.842 3.417 5.17 5.816 2.328 2.4 3.671 4.644 7.316 2.032 2.772-1.987 1.808-4.566.444-7.332-1.362-2.765-2.675-5.356-4.162-7.466",
  fill: "#F5AD7F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.73 117.69a1.332 1.332 0 110 2.665 1.332 1.332 0 010-2.665",
  fill: "#EDAA85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.745 115.11a1.332 1.332 0 11.001 2.664 1.332 1.332 0 010-2.664",
  fill: "#EDAA85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.335 112.898a1.332 1.332 0 110 2.664 1.332 1.332 0 010-2.664M35.205 109.905a1.87 1.87 0 110 3.74 1.87 1.87 0 010-3.74",
  fill: "#EDAA85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.344 129.506c8.367-.848 13.647-10.053 13.179-17.245-.382-5.864-7.847-7.95-14.836-6.847-4.536 5.16-7.787 17.575-6.92 18.363.868.787 4.354.292 6.49-.003 4.27-.59 2.087 5.732 2.087 5.732",
  fill: "#F5BE9E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.191 115.07c1.612-2.284 3.881-4.674 7.158-1.795 3.277 2.878 2.931 7.066 1.61 8.746-1.32 1.681-2.842 3.417-5.17 5.816-2.328 2.4-3.671 4.644-7.316 2.032-2.772-1.987-1.808-4.566-.444-7.332 1.362-2.765 2.675-5.356 4.162-7.466",
  fill: "#F5AD7F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.246 117.69a1.332 1.332 0 110 2.665 1.332 1.332 0 010-2.665M88.23 115.11a1.332 1.332 0 11.001 2.665 1.332 1.332 0 010-2.665",
  fill: "#EDAA85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.641 112.898a1.332 1.332 0 110 2.664 1.332 1.332 0 010-2.664M83.77 109.905a1.87 1.87 0 110 3.74 1.87 1.87 0 010-3.74",
  fill: "#EDAA85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.687 105.414c6.955-.283 12.21 2.73 12.614 6.362.533 4.805-2.738 14.555-10.957 17.731 8.367-.849 13.646-10.054 13.178-17.246-.381-5.864-7.846-7.95-14.835-6.847M77.918 90.619l.135-1.284c3.297.346 4.33.592 5.34-1.759l.51-.105s-.7 3.74-5.985 3.148",
  fill: "#F5AD7F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.738 56.31l.516 4.426c0 .849 1.085 1.566 2.37 1.566h5.054c1.286 0 2.372-.717 2.372-1.566l.005-.084.51-4.343c-.03-.833-1.103-1.53-2.37-1.53h-6.086c-1.267 0-2.34.697-2.37 1.53m7.94 7.437h-5.054c-2.084 0-3.783-1.326-3.814-2.964l-.517-4.436c0-1.66 1.712-3.01 3.815-3.01h6.086c2.103 0 3.814 1.35 3.814 3.01l-.005.084-.512 4.352c-.03 1.638-1.73 2.964-3.814 2.964M62.608 56.31l.516 4.426c0 .849 1.086 1.566 2.371 1.566h5.053c1.286 0 2.372-.717 2.372-1.566l.005-.084.51-4.343c-.03-.833-1.103-1.53-2.37-1.53h-6.086c-1.267 0-2.34.697-2.37 1.53m7.94 7.437h-5.054c-2.084 0-3.783-1.326-3.814-2.964l-.517-4.436c0-1.66 1.712-3.01 3.815-3.01h6.086c2.103 0 3.815 1.35 3.815 3.01l-.005.084-.512 4.352c-.031 1.638-1.731 2.964-3.815 2.964",
  fill: "#E81A1A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.605 57.333c-.863-.365-3.394-.403-3.924-.06l-.786-1.21c1.125-.73 4.266-.485 5.272-.06l-.562 1.33zM38.06 57.21a.722.722 0 01-.157-1.427c2.066-.462 6.95-.17 7.157-.158.398.025.7.367.676.765a.726.726 0 01-.764.676c-.049-.003-4.886-.292-6.754.126a.737.737 0 01-.158.017M80.949 57.203a.751.751 0 01-.12-.01c-2.08-.347-6.59-.129-6.635-.127a.722.722 0 01-.072-1.442c.191-.009 4.71-.228 6.944.146a.722.722 0 01-.117 1.433",
  fill: "#E81A1A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.48 107.28c0 .963-.781 1.744-1.744 1.744H59.09a1.744 1.744 0 01-1.744-1.744V81.966c0-.963.781-1.744 1.744-1.744h19.646c.963 0 1.744.78 1.744 1.744v25.314z",
  fill: "#FCE55A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.206 81.987a.363.363 0 01-.363-.363v-2.05a.363.363 0 01.725 0v2.05c0 .2-.162.363-.362.363M60.824 81.987a.363.363 0 01-.363-.363v-2.05a.363.363 0 01.725 0v2.05c0 .2-.162.363-.362.363M62.441 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 11.725 0v2.05c0 .2-.163.363-.363.363M64.059 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 11.725 0v2.05c0 .2-.163.363-.363.363M65.677 81.987a.363.363 0 01-.363-.363v-2.05a.363.363 0 01.726 0v2.05c0 .2-.163.363-.363.363M67.295 81.987a.363.363 0 01-.363-.363v-2.05a.363.363 0 11.726 0v2.05c0 .2-.163.363-.363.363M68.913 81.987a.363.363 0 01-.363-.363v-2.05a.363.363 0 11.726 0v2.05c0 .2-.163.363-.363.363M70.53 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 11.726 0v2.05c0 .2-.163.363-.363.363M72.148 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 11.726 0v2.05c0 .2-.163.363-.364.363M73.766 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 01.725 0v2.05c0 .2-.162.363-.363.363M75.384 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 11.725 0v2.05c0 .2-.162.363-.363.363M77.002 81.987a.363.363 0 01-.362-.363v-2.05a.363.363 0 11.725 0v2.05c0 .2-.162.363-.363.363M78.62 81.987a.363.363 0 01-.363-.363v-2.05a.363.363 0 01.726 0v2.05c0 .2-.162.363-.363.363",
  fill: "#898989"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1FADDF",
  d: "M57.346 85.26H80.48v-.241H57.346zM57.346 88.198H80.48v-.242H57.346zM57.346 91.135H80.48v-.241H57.346zM57.346 94.074H80.48v-.242H57.346zM57.346 97.01H80.48v-.241H57.346zM57.346 99.948H80.48v-.242H57.346zM57.346 102.886H80.48v-.242H57.346zM57.346 105.823H80.48v-.242H57.346z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#E59E7A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.122 102.055a2.258 2.258 0 010-4.516l4.635-.001a2.258 2.258 0 01.001 4.516l-4.635.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.47 97.806a2.258 2.258 0 010-4.516l4.636-.002a2.258 2.258 0 01.001 4.516l-4.636.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.37 93.476a2.258 2.258 0 01-.001-4.516l4.636-.001a2.258 2.258 0 01.001 4.516l-4.636.001z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M77.012 102.498a2.258 2.258 0 010-4.516l4.635-.002a2.258 2.258 0 01.002 4.516l-4.636.002z",
  fill: "#F4B798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.36 98.249a2.258 2.258 0 01-.001-4.516l4.637-.003a2.258 2.258 0 01.002 4.516l-4.637.003h-.001z",
  fill: "#F4B798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.26 93.919a2.258 2.258 0 01-.002-4.516l4.636-.001a2.258 2.258 0 01.001 4.516l-4.635.001z",
  fill: "#F4B798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.888 98.359h-.004l-4.268-.112a.161.161 0 01-.157-.165.166.166 0 01.165-.158l4.269.112a.162.162 0 01-.005.323M80.91 94.01l-4.459-.002a.161.161 0 110-.322h4.459a.161.161 0 010 .323",
  fill: "#F5AD7F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.83 79.688a1.294 1.294 0 00-1.64-.8l-.446.153a1.294 1.294 0 00-.801 1.64l.734 2.135c.231.671.97 1.032 1.64.801l.446-.153a1.294 1.294 0 00.8-1.64l-.734-2.136z",
  fill: "#F490B5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2E233",
  d: "M42.354 81.213l-2.886.993 7.958 23.144 2.886-.992z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#528927",
  d: "M43.183 83.624l-2.887.993-.828-2.41 2.886-.994z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2E233",
  d: "M42.885 82.759l-2.886.992-.213-.618 2.886-.993z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5B554F",
  d: "M50.01 108.204l.08-1.025-.769.264z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EACAA4",
  d: "M49.74 104.148l-.362.506-.634-.163-.415.528-.564-.192-.34.523 1.896 2.093.769-.264.221-2.821z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.744 79.041c-.672.23-.67.239.004.019a1.317 1.317 0 011.645.819l.722 2.1c.23.67.52 1.185.643 1.142.124-.042.036-.626-.195-1.297l-.734-2.136a1.294 1.294 0 00-1.64-.8l-.445.153z",
  fill: "#D37A9F"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BCB833",
  d: "M41.917 81.404l7.946 23.108.448-.154-7.957-23.145z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3C601D",
  d: "M41.917 81.404l.817 2.374.45-.154-.83-2.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BCB833",
  d: "M42.222 82.29l.214.624.45-.155-.214-.619z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#302C28",
  d: "M49.657 107.328l-.035.447.387.43.08-1.026z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D1B597",
  d: "M49.74 104.148l-.199.278.334.122-.218 2.78.433-.149.221-2.821z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#E59E7A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.5 102.794a2.258 2.258 0 01-.442-4.472l4.541-.912a2.259 2.259 0 01.89 4.428l-4.542.912c-.15.03-.3.044-.447.044"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.318 98.699a2.259 2.259 0 01-.442-4.472l4.543-.912a2.258 2.258 0 11.889 4.428l-4.543.911c-.15.03-.3.045-.447.045"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.562 94.436a2.259 2.259 0 01-.442-4.472l4.542-.912a2.258 2.258 0 01.889 4.428l-4.542.911c-.15.03-.3.045-.447.045"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.912 102.6a2.259 2.259 0 01-.442-4.473l4.542-.912a2.258 2.258 0 01.889 4.428l-4.542.912c-.15.03-.3.044-.447.044",
  fill: "#F4B798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.73 98.504a2.258 2.258 0 01-.443-4.472l4.543-.913a2.258 2.258 0 01.89 4.428l-4.543.912c-.15.03-.3.045-.447.045",
  fill: "#F4B798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.974 94.241a2.258 2.258 0 01-.442-4.472l4.542-.913a2.258 2.258 0 01.89 4.428l-4.543.912c-.15.03-.3.045-.447.045",
  fill: "#F4B798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.255 98.353a.16.16 0 01-.036-.318l4.159-.952a.161.161 0 11.071.314l-4.159.952a.153.153 0 01-.035.004M44.374 94.094a.162.162 0 01-.031-.32l4.368-.88a.161.161 0 01.064.316l-4.369.881a.159.159 0 01-.032.003",
  fill: "#F5AD7F"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M166.486 89c.65 0 1.176.526 1.176 1.176v3.134h3.135c.606 0 1.105.46 1.17 1.048l.006.128c0 .65-.526 1.176-1.176 1.176h-3.135v3.135c0 .606-.458 1.105-1.047 1.17l-.129.006c-.649 0-1.175-.526-1.175-1.176l-.001-3.135h-3.134a1.176 1.176 0 01-1.17-1.047l-.006-.129c0-.649.526-1.175 1.176-1.175l3.134-.001v-3.134c0-.606.46-1.105 1.048-1.17z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60 0c.592 0 1.071.48 1.071 1.071v2.857h2.858c.552 0 1.007.418 1.065.955L65 5c0 .592-.48 1.071-1.071 1.071H61.07v2.858c0 .552-.417 1.007-.954 1.065L60 10c-.592 0-1.071-.48-1.071-1.071l-.001-2.858h-2.857a1.072 1.072 0 01-1.065-.954L55 5c0-.592.48-1.071 1.071-1.071l2.857-.001V1.071c0-.552.418-1.007.955-1.065z",
  fill: "#0086D8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#DA4D7A",
  cx: 2.5,
  cy: 74.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#913FA3",
  cx: 146.5,
  cy: 133.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#0086D8",
  strokeWidth: 2,
  cx: 19.5,
  cy: 127.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#44C94E",
  strokeWidth: 2,
  cx: 140.5,
  cy: 25.5,
  r: 3.5
}));

function SvgDap6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 167,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 17)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("g", {
    mask: "url(#DAP_6_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 119.726)"
  }, _ref7, /*#__PURE__*/React.createElement("path", {
    d: "M39.982.306c22.081 0 39.982 3.34 39.982 7.458 0 4.119-17.9 7.458-39.982 7.458S0 11.883 0 7.764 17.9.306 39.982.306",
    fill: "#B3DAF2",
    opacity: 0.63,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#DAP_6_svg__e)"
  })), _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19)), _ref20));
}

export default __webpack_public_path__ + "static/DAP_6.4ed4d88c.svg";
export { SvgDap6 as ReactComponent };